export enum BusinessType {
  CARRIER = 'carrier',
  LOGISTIC_OPERATOR = 'logistic-operator',
  SENDER = 'sender',
}
